export const details = {
	capital: {
		en: "capital",
		ko: "수도",
		zh: "首都",
	},
	language: {
		en: "language",
		ko: "언어",
		zh: "语言",
	},
	continent: {
		en: "continent",
		ko: "대륙",
		zh: "洲",
	},
	currency: {
		en: "currency",
		ko: "통화",
		zh: "货币",
	},
	population: {
		en: "population",
		ko: "인구",
		zh: "人口",
	},
	more: {
		en: "more",
		ko: "더 보기",
		zh: "更多",
	},
};
